import React from "react";
import { ThemeProvider } from "@emotion/react";
import { ClientProvider, TranslationProvider, FeatureFlagsProvider, } from "../../hooks";
import { lightTheme, darkTheme } from "../Window/themes";
const Chat = ({ theme = "light", strings, client, children, showReactions, showReplies, storageUrl, showImagePreview, }) => {
    if (!client)
        return React.createElement("p", null, "Loading...");
    return (React.createElement(ClientProvider, { client: client },
        React.createElement(ThemeProvider, { theme: theme === "light" ? lightTheme : darkTheme },
            React.createElement(TranslationProvider, { translations: strings },
                React.createElement(FeatureFlagsProvider, { replies: showReplies, reactions: showReactions, storageUrl: storageUrl, imagePreview: showImagePreview }, children)))));
};
export default Chat;
//# sourceMappingURL=Chat.js.map